import CryptoJS from 'crypto-js'

// const CRYPTO_KEY = 'pptist'

/**
 * 加密
 * @param msg 待加密字符串
 */
export const encrypt = (msg: string) => {
  // return CryptoJS.AES.encrypt(msg, CRYPTO_KEY).toString()
  const keyStr = 'l36DoqKUYQP0N7e1' // 密钥

  const ivStr = '131b0c8a7a6e072e' // 偏移量

  const key = CryptoJS.enc.Utf8.parse(keyStr) // 解析后的key

  const iv = CryptoJS.enc.Utf8.parse(ivStr) // 解析后的iv

  const srcs = CryptoJS.enc.Utf8.parse(msg)

  const encrypted = CryptoJS.AES.encrypt(srcs, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7})

  return encrypted.toString()
}

/**
 * 解密
 * @param ciphertext 待解密字符串
 */
export const decrypt = (ciphertext: string) => {
  // const bytes = CryptoJS.AES.decrypt(ciphertext, CRYPTO_KEY)
  // return bytes.toString(CryptoJS.enc.Utf8)
  const keyStr = 'l36DoqKUYQP0N7e1'

  const ivStr = '131b0c8a7a6e072e'

  const base64 = CryptoJS.enc.Utf8.parse(ciphertext) // Base64解密

  const key = CryptoJS.enc.Utf8.parse(keyStr) // 解析后的key

  const iv = CryptoJS.enc.Utf8.parse(ivStr) // 解析后的iv

  const src = CryptoJS.enc.Utf8.stringify(base64) // Base64解密

  const decrypt = CryptoJS.AES.decrypt(src, key, {iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7})

  return decrypt.toString(CryptoJS.enc.Utf8)
}
